"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userIsAuthorized = exports.REQUEST_METHOD_ACTION_MAP = void 0;
const ROLE_ACTIONS = {
    OWNER: ['create', 'read', 'update', 'delete'],
    EDITOR: ['read', 'update'],
    VIEWER: ['read']
};
exports.REQUEST_METHOD_ACTION_MAP = {
    ['post']: 'create',
    ['get']: 'read',
    ['put']: 'update',
    ['patch']: 'update',
    ['delete']: 'delete'
};
function userIsAuthorized(tenantResourceRoles, requestPermission) {
    let authorized = false;
    // Check if user has a resource role for the requested tenant
    const userTenantPermissions = tenantResourceRoles ? tenantResourceRoles[requestPermission.tenantId] : null;
    // This fails because the user does not have permissions for the tenant
    if (!userTenantPermissions) {
        authorized = false;
    }
    // Get the role for the requested resource
    const userTenantResourceRole = userTenantPermissions ? userTenantPermissions[requestPermission.resource] : null;
    if (!userTenantResourceRole) { // This fails because the user does not have a role for requested resource
        authorized = false;
    }
    else if (userTenantResourceRole && requestPermission.resource === 'help_viewer') { //for 'help_viewer', the resource being present is enough to allow Help page access
        authorized = true;
    }
    else if (userTenantResourceRole && ROLE_ACTIONS[userTenantResourceRole].includes(requestPermission.action)) { // Check if the user's tenantResourceRole contains the required action
        authorized = true;
    }
    // If the user has permissions on all tenants,
    // call function again to check for valid resource role under all
    if (!authorized &&
        tenantResourceRoles &&
        tenantResourceRoles['ALL'] &&
        requestPermission.tenantId !== 'ALL') {
        return userIsAuthorized(tenantResourceRoles, {
            action: requestPermission.action,
            resource: requestPermission.resource,
            tenantId: 'ALL',
        });
    }
    return authorized;
}
exports.userIsAuthorized = userIsAuthorized;
